import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

const Callback: React.FC = () => {
  const history = useHistory();
  useEffect(() => {
    history.replace('/');
  }, []);
  return <></>;
};

export default Callback;
